module.exports = __webpack_public_path__ + "static/img/elte.8ccb443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/support/elte.jpg
// module id = 368
// module chunks = 2